/**
 * Les lectures de « Mon historique de lives » : `getTutorLiveOccurrences`, page par page (l'ancien
 * `PaginatedTableM` de `LivesHistory`), et la recherche du serveur (l'ancien `ServerSearch` : le texte
 * part 500 ms après la dernière frappe, la liste repart de la page 1).
 *
 * La page en cours et le total sont copiés de `meta` (`useApiPagedFetch`) ; la recherche est ici
 * parce qu'elle décide de la lecture. La réponse d'une recherche dépassée ne bouge pas le curseur.
 */
import { useEffect, useState } from "react"

import { tutorsService } from "../../../../../../data/services/tutorsService"
import { useApiPagedFetch } from "../../../hooks/useApiPagedFetch"

/** Le délai de l'ancien `ServerSearch` entre la dernière frappe et la lecture. */
const HISTORY_SEARCH_DEBOUNCE_MS = 500

const searchParams = (text: string) => (text ? { search: text } : {})

export function useTutorLivesHistoryData() {
    const [query, setQuery] = useState("")
    /** Le texte qui a parti la dernière lecture : la suite des pages le reprend. */
    const [search, setSearch] = useState("")
    const pages = useApiPagedFetch({ service: tutorsService.getTutorLiveOccurrences, scopeUrlParams: ["search"] })
    const { refresh } = pages

    // 500 ms après la dernière frappe, la liste repart de la page 1 sur le nouveau texte.
    useEffect(() => {
        if (query === search) return
        const timer = setTimeout(() => {
            setSearch(query)
            refresh(searchParams(query))
        }, HISTORY_SEARCH_DEBOUNCE_MS)
        return () => clearTimeout(timer)
    }, [query, search, refresh])

    return {
        query,
        setQuery,
        refresh: () => refresh(),
        loadMore: pages.loadMore,
        // Une page en échec ne laisse pas croire qu'il en reste : le pied relance la même.
        hasMore: pages.hasMore && !pages.loadMoreFailed,
        totalCount: pages.totalCount,
    }
}
